import { createSlice } from '@reduxjs/toolkit';

export const backdropSlice = createSlice({
  name: 'backdrop',
  initialState: { open: false },
  reducers: {
    showBackdrop: state => {
      state.open = true;
    },
    hideBackdrop: state => {
      state.open = false;
    },
  },
});
